import { ArrowRightIcon, X } from "lucide-react";
import { getSeq } from "../../../../../helpers/get-seq";
import { Button } from "../button";
import "./index.scss";

interface HamburgerMenuProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ isOpen, onToggle }) => {
  return (
    <Button onClick={onToggle} className="HamburgerMenu" aria-label="Toggle menu">
      <div className="HamburgerMenu-icon">
        <span className={`HamburgerMenu-line ${isOpen ? "isOpen" : ""}`} />
        <span className={`HamburgerMenu-line ${isOpen ? "isOpen" : ""}`} />
        <span className={`HamburgerMenu-line ${isOpen ? "isOpen" : ""}`} />
      </div>
    </Button>
  );
};

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  navItems: Array<{ label: string; href: string }>;
  onPlatformAccess?: () => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({
  isOpen,
  onClose,
  navItems,
  onPlatformAccess,
}) => {
  return (
    <>
      <div className={`MobileMenu-overlay ${isOpen ? "" : "isClosed"}`} onClick={onClose} />

      <div className={`MobileMenu-container ${isOpen ? "isOpen" : ""}`}>
        <div className="MobileMenu-header">
          <h3 className="MobileMenu-title">Menu</h3>
          <Button onClick={onClose} className="MobileMenu-closeBtn" aria-label="Close menu">
            <X />
          </Button>
        </div>

        <nav className="MobileMenu-nav">
          <ul className="MobileMenu-list">
            {navItems.map((item, index) => (
              <div
                key={`landing-page-navitem-${getSeq()}-${index}`}
                className={`MobileMenu-item ${isOpen ? "isOpen" : ""}`}
              >
                <li>
                  <a href={item.href} onClick={onClose} className="MobileMenu-link">
                    <span className="MobileMenu-linkContent">
                      {item.label}
                      <ArrowRightIcon className="MobileMenu-linkIcon" />
                    </span>
                  </a>
                </li>
              </div>
            ))}
          </ul>
        </nav>

        <div className="MobileMenu-footer">
          <div className={`MobileMenu-footerContent ${isOpen ? "" : "isClosed"}`}>
            <Button
              onClick={() => {
                onClose();
                onPlatformAccess?.();
              }}
              className="MobileMenu-accessBtn"
            >
              Accès plateforme
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
